import React from 'react';
import { Fab } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { useConfirm } from 'material-ui-confirm';
import useIsKioskMode from '../../../hooks/useIsKioskMode';
import { exitKioskMode } from '../../../hooks/useKioskIdleReset';
import { resetCheckoutGql } from '../gql';

export default function KioskExitButton() {
  const isKioskMode = useIsKioskMode();
  const { slug } = useParams();
  const { t } = useTranslation('kiosk');
  const confirm = useConfirm();
  const [resetCheckout] = useMutation(resetCheckoutGql, {
    variables: { slug },
  });

  if (!isKioskMode) return null;

  const handleClick = async () => {
    try {
      await confirm({
        title: t('endSessionConfirmTitle'),
        description: t('endSessionConfirmDescription'),
        confirmationText: t('endSessionConfirmButton'),
        cancellationText: t('endSessionCancelButton'),
      });
    } catch (error) {
      return;
    }
    exitKioskMode(slug, resetCheckout);
  };

  return (
    <Fab
      onClick={handleClick}
      aria-label={t('endSession')}
      sx={{
        position: 'fixed',
        top: { xs: 16, md: 32 },
        right: { xs: 16, md: 32 },
        zIndex: 1300,
        bgcolor: 'background.paper',
        color: 'text.secondary',
      }}
    >
      <CloseIcon />
    </Fab>
  );
}
